<template>
  <div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
      <div id="sidebar-wrapper" class="border-right">
        <div class="header-sidebar" slot="header">
          <img :src="basepath+'/unodc_logo.png'" alt width="200" />
        </div>
        <div class="list-group list-group-flush pl-4 pr-4">
          <h5 class="mb-0">Filter By</h5>
          <hr />
          <h6>Funding Agency</h6>
          <selectize v-model="filter.fundingAgency" :settings="settings">
            <!-- settings is optional -->
            <option
              v-for="(item,index) in fundingAgencyArr"
              :key="index"
              :value="item.id"
            >{{item.title}}</option>
          </selectize>
          <hr />
          <!-- <h6>Date</h6> -->
          <div class="row">
            <div class="col-sm-12">
              <h6 class="label-control">Start Date</h6>
              <flat-pickr
                class="form-control"
                style="background: #fff"
                placeholder="Select start date"
                v-model="filter.startDate"
                :config="dateOptions"
              ></flat-pickr>
            </div>
            <div class="col-sm-12 mt-3">
              <h6 class="label-control">End Date</h6>
              <flat-pickr
                class="form-control"
                style="background: #fff"
                placeholder="Select end date"
                v-model="filter.endDate"
                :config="dateOptions"
              ></flat-pickr>
            </div>
          </div>
          <hr />
          <h6>Code No.</h6>
          <input type="text" v-model="filter.codeNo" class="form-control" />

          <hr />
          <h6>Thematic Area</h6>
          <selectize v-model="filter.thematicArea" :settings="settings">
            <!-- settings is optional -->
            <option
              v-for="(item,index) in thematicAreaArr"
              :key="index"
              :value="item.id"
            >{{item.name}}</option>
          </selectize>

          <hr />
          <h6>Training Type</h6>
          <selectize v-model="filter.trainingType">
            <!-- settings is optional -->
            <option value="1">WorkShop</option>
            <option value="2">Training</option>
          </selectize>

          <hr />
          <h6>Project</h6>
          <selectize v-model="filter.project">
            <!-- settings is optional -->
            <option v-for="(item,index) in projectArr" :key="index" :value="item.id">{{item.title}}</option>
          </selectize>

          <hr />
          <h6>Subprogram</h6>
          <selectize v-model="filter.subProgram">
            <!-- settings is optional -->
            <option
              v-for="(item,index) in subProgramArr"
              :key="index"
              :value="item.id"
            >{{item.title}}</option>
          </selectize>
          <hr />
          <h6>Program Officer</h6>
          <selectize v-model="filter.programOfficer">
            <!-- settings is optional -->
            <option
              v-for="(item,index) in programOfficerArr"
              :key="index"
              :value="item.id"
            >{{item.name}}</option>
          </selectize>
          <hr />
          <h6>Advisor</h6>
          <selectize v-model="filter.advisor">
            <!-- settings is optional -->
            <option v-for="(item,index) in advisorArr" :key="index" :value="item.id">{{item.name}}</option>
          </selectize>
          <hr />
          <div>
            <button
              style="margin-right:5px; font-size:12px"
              class="btn btn-primary"
              @click="filterTraining()"
            >Apply</button>
            <button style="font-size:12px" class="btn btn-danger" @click="resetTraining()">Reset</button>
            <hr style="margin-bottom:25rem" />
          </div>
        </div>
      </div>
      <div id="page-content-wrapper" style="width:100%">
        <i class="material-icons" id="menu-toggle" @click="isSidebar =  !isSidebar">view_headline</i>
        <app-navbar></app-navbar>
        <div class="container-fluid mt-5">
          <div class="row">
            <div class="col-sm-12">
              <div class="heading mt-3">
                <vs-breadcrumb
                  align="left"
                  :items="
                  [
                    {title: 'You are here : '},
                    {
                      title: 'Dashboard',
                      url: '/#/dashboard/Admin/adminDashboard',
                    },
                    {
                      title: 'Trainings',
                      url: '#',
                      active: true
                    }
                  ]"
                ></vs-breadcrumb>
                <h3 class="text-secondary">Trainings</h3>
              </div>
            </div>
          </div>
          <div class="row">
            <!--  style="padding: 5px;box-shadow: 0 0 15px 0 rgba(0,0,0,.05);" -->
            <label
              v-if="trainingArr.length == 0"
              style="color:Red;font-weight:bold;width: 100%;text-align: center;"
            >No records found !</label>
            <vs-col
              v-for="(trainer,index) in trainingArr"
              :key="index"
              class="card-col"
              type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="4"
            >
              <div class="h-100">
                <router-link
                  :to="{ path: '/dashboard/Admin/Reports', query: { trainingId: trainer.id }}"
                >
                  <vs-card actionable class="cardx main-card bg-c-lite-green h-100">
                    <div slot="header" class="cardheader">
                      <div slot="media"></div>
                      <h5 class="training-title">{{trainer.title}}</h5>
                    </div>

                    <div slot="footer" class="crd-footer">
                      <vs-row vs-justify="center" style="display: inline-grid;">
                        <ul class="date-ul" style="margin-left: -50px;">
                          <li class="start-date">
                            <b>Start Date:</b>
                            {{trainer.startdate}}
                          </li>
                          <li class="end-date">
                            <b>End Date:</b>
                            {{trainer.enddate}}
                          </li>
                        </ul>
                        <br />
                      </vs-row>
                    </div>
                  </vs-card>
                </router-link>
              </div>
            </vs-col>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Selectize from "vue2-selectize";
import Navbar from "./Navbar";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.css";

// flatPickr
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
// Import this component
// Import date picker css
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
export default {
  data: () => ({
    active: true,
    isSidebar: false,
    basepath: process.env.VUE_APP_BASE_PATH,
    colorx: "warning",
    ApprovedTrainingME: [],
    trainingArr: [],
    datesArr: [],
    settings: {
      maxItems: null,
      plugins: ["remove_button"],
      delimiter: "|"
    },
    fundingAgencyArr: "",
    thematicAreaArr: "",
    projectArr: "",
    subProgramArr: "",
    programOfficerArr: "",
    advisorArr: "",
    filterArr: [],
    filter: {
      fundingAgency: "",
      startDate: "",
      endDate: "",
      codeNo: "",
      thematicArea: "",
      trainingType: "",
      project: "",
      subProgram: "",
      programOfficer: "",
      advisor: "",
      trainers: ""
    },
    dateOptions: {
      wrap: true,
      weekNumbers: true,
      dateFormat: "d-m-Y"
    }
  }),
   mounted() {
   axios.defaults.headers['Authorization'] = localStorage.getItem('token')
    // Set the initial number of items
    // this.totalRows = this.items.length;
    this.openLoading();
    axios
      .get(process.env.VUE_APP_BASE_PATH + "/thematic/get/all/"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.thematicAreaArr = response.data;
      });

    this.openLoading();
    axios
      .get(process.env.VUE_APP_BASE_PATH + "/filter/project/get/"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.projectArr = response.data;
      });

    this.openLoading();
    axios
      .get(process.env.VUE_APP_BASE_PATH + "/filter/subprogram/get/"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.subProgramArr = response.data;
      });

    this.openLoading();
    axios
      .get(process.env.VUE_APP_BASE_PATH + "/filter/programofficer/get/"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.programOfficerArr = response.data;
      });

    this.openLoading();
    axios
      .get(process.env.VUE_APP_BASE_PATH + "/filter/advisor/get/"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.advisorArr = response.data;
      });

    this.openLoading();
    axios
      .get(process.env.VUE_APP_BASE_PATH + "/filter/fundingagency/get/"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.fundingAgencyArr = response.data;
      });

    this.openLoading();
    axios
      .get(process.env.VUE_APP_BASE_PATH + "/report/training/get"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.filterArr = response.data;
        this.trainingArr = this.filterArr;
        this.closeLoading();
      });
  },
  components: {
    "app-navbar": Navbar,
    Selectize,
    flatPickr
  },
  methods: {
    openLoading() {
      this.$vs.loading({
        type: "material"
      });
    },
    closeLoading() {
      this.$vs.loading.close();
    },
    makeActive() {
      alert("Worked");
    },
    filterTraining() {
      let a = this;
      this.openLoading();
      this.trainingArr = this.filterArr.filter(function(item) {
        let itemPass = true;
        if (a.filter.fundingAgency != "" && itemPass) {
          let send = true;
          a.filter.fundingAgency.map((val) => {
            if (send) {
              if (item.doner_id.includes(val)) {
                send = true;
              } else {
                send = false;
              }
            }
          });
          if (send) {
            itemPass = true;
          } else {
            itemPass = false;
          }
        }
        if (a.filter.startDate != "" && itemPass) {
          if (a.filter.startDate === item.startdate) {
            itemPass = true;
          } else {
            itemPass = false;
          }
        }
        if (a.filter.endDate != "" && itemPass) {
          if (item.enddate == a.filter.endDate) {
            itemPass = true;
          } else {
            itemPass = false;
          }
        }
        if (a.filter.codeNo != "" && itemPass) {
          if (item.id == a.filter.codeNo) {
            itemPass = true;
          } else {
            itemPass = false;
          }
        }
        if (a.filter.thematicArea != "" && itemPass) {
          let send = true;
          a.filter.thematicArea.map((val) => {
            if (send) {
              if (item.thematic_id.includes(val)) {
                send = true;
              } else {
                send = false;
              }
            }
          });
          if (send) {
            itemPass = true;
          } else {
            itemPass = false;
          }
        }
        if (a.filter.trainingType != "" && itemPass) {
          if (item.typetraining_id == a.filter.trainingType) {
            itemPass = true;
          } else {
            itemPass = false;
          }
        }
        if (a.filter.project != "" && itemPass) {
          if (item.project_id == a.filter.project) {
            itemPass = true;
          } else {
            itemPass = false;
          }
        }
        if (a.filter.subProgram != "" && itemPass) {
          if (item.subprogram_id == a.filter.subProgram) {
            itemPass = true;
          } else {
            itemPass = false;
          }
        }
        if (a.filter.programOfficer != "" && itemPass) {
          if (item.programofficer_id == a.filter.programOfficer) {
            itemPass = true;
          } else {
            itemPass = false;
          }
        }
        if (a.filter.advisor != "" && itemPass) {
          if (item.advisor_id == a.filter.advisor) {
            itemPass = true;
          } else {
            itemPass = false;
          }
        }
        if (itemPass) {
          return item;
        }
      });

      setTimeout(() => {
        this.closeLoading();
      }, 1);
    },
    resetTraining() {
      this.openLoading();
      this.trainingArr = this.filterArr;
      this.filter = {
        fundingAgency: "",
        startDate: "",
        endDate: "",
        codeNo: "",
        thematicArea: "",
        trainingType: "",
        project: "",
        subProgram: "",
        programOfficer: "",
        advisor: "",
        trainers: ""
      };

      setTimeout(() => {
        this.closeLoading();
      }, 1);
    }
  }
};
</script>

<style scoped>
#menu-toggle {
  display: none;
}

@media (max-width: 768px) {
  #menu-toggle {
    display: block;
  }
}
#page-content-wrapper {
  width: 100%;
  position: relative;
  /* left: 130px; */
}
.active {
  background: #dff0d8 !important;
  /* color:#fff !important; */
}
.active.training-title-cards {
  color: #fff !important;
}
ul.date-ul {
  display: inline-flex;
}
.date-ul li.start-date {
  padding-right: 35px;
}
.cards-row {
  margin-top: 10px !important;
}
.card-col {
  padding: 5px !important;
}
.main-card {
  color: #6c757d;
  border: 1px dotted #07a7e14f;
}
.main-card:hover {
  border: 1px solid #07a7e14f;
}
.training-title {
  /* font-size: 15px; */
  font-weight: 500;
  /* color: #212529 !important; */
}
.training-title-cards {
  font-size: 15px;
  font-weight: 500;
  /* color: #212529; */
}
.con-vs-card.withHover:hover img {
  -webkit-transform: scale(1);
  transform: scale(1);
}
.cardheader {
  display: inline-flex;
}

@media (max-width: 768px) {
  .card-col {
    width: 100% !important;
  }
  ul.date-ul {
    margin-top: 5px;
  }
  .date-ul li.start-date {
    padding-right: 26px;
  }
  .training-title {
    font-size: 14px;
  }
}
@media (max-width: 991.98px) {
  .date-ul li.start-date {
    padding-right: 26px;
  }
  .card-col {
    width: 100% !important;
  }
  ul.date-ul {
    margin-top: 5px;
  }
}

@media print {
  #sidebar-wrapper {
    display: none;
  }
}

.con-vs-checkbox {
  justify-content: start;
}

/*!
 * Start Bootstrap - Simple Sidebar (https://startbootstrap.com/template-overviews/simple-sidebar)
 * Copyright 2013-2019 Start Bootstrap
 * Licensed under MIT (https://github.com/BlackrockDigital/startbootstrap-simple-sidebar/blob/master/LICENSE)
 */

body {
  overflow-x: hidden;
}

.material-icons {
  font-size: 20px !important;
  vertical-align: bottom;
}
#sidebar-wrapper {
  min-height: 100vh;
  margin-left: -15rem;
  -webkit-transition: margin 0.25s ease-out;
  -moz-transition: margin 0.25s ease-out;
  -o-transition: margin 0.25s ease-out;
  transition: margin 0.25s ease-out;
}

#sidebar-wrapper .sidebar-heading {
  padding: 0.875rem 1.25rem;
  font-size: 1.2rem;
}

#sidebar-wrapper .list-group {
  width: 15rem;
}

#page-content-wrapper {
  min-width: 100vw;
}

#wrapper.toggled #sidebar-wrapper {
  margin-left: 0;
}

@media (min-width: 768px) {
  #sidebar-wrapper {
    margin-left: 0;
  }

  #page-content-wrapper {
    min-width: 0;
    width: 100%;
  }

  #wrapper.toggled #sidebar-wrapper {
    margin-left: -15rem;
  }
}

.con-vs-checkbox {
  justify-content: start;
}
#sidebar-wrapper {
  width: 290px;
  overflow-y: visible;
  overflow-x: hidden;
}
</style>

